import Common from "./common"

export const hideUrlForCountry = function (country) {
    switch (country?.toLowerCase()) {
        case 'us':
            console.log("country", country)
            return true
        case 'usa':
            return true
        case 'united states of america':
            return true
        case 'united states':
            return true
        case 'america':
            return true
        case 'u.s.a':
            return true
        default:
            return false
    }
}

export const hideUrlForAge = function () {
    const userDateOfBirth = JSON.parse(window.localStorage.getItem('date_of_birth'));

    // if (!userDateOfBirth) {
        const is_mature = JSON.parse(window.localStorage.getItem('is_mature'));
        // const is_mature = user?.is_mature;
        // console.log(is_mature)
        return is_mature;
    // }
    
    // if (userDateOfBirth) {
    //     const birthDate = new Date(userDateOfBirth);
    //     const today = new Date();

    //     let age = today.getFullYear() - birthDate.getFullYear();
    //     const monthDiff = today.getMonth() - birthDate.getMonth();
    //     const dayDiff = today.getDate() - birthDate.getDate();

    //     if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    //         age--;
    //     }

    //     return age >= 18;
    // }

    // return false;
};

export const checkIsCouponUser = () => {
    const paths = Common.LANDING_PAGES;
    let routePath = window.location.pathname?.toLowerCase().split("/")[1]
    let isCouponUser = paths.find(f => f.toLocaleLowerCase() === routePath.toLocaleLowerCase())
    return isCouponUser
}

export const isUserComeFromDealRoute = () => {
    const routes = Common.DEAL_PAGES;
    let pathname = window.location.pathname?.toLowerCase().split("/")[1]
    let routeMatched = routes.find(f => f.toLocaleLowerCase() === pathname.toLocaleLowerCase())
    return routeMatched
}


